import { useEffect } from "react";
import Layout from "../Layout"
import M from 'materialize-css/dist/js/materialize.min';
import CampusImages from "./CampusImages";
import Education from "./Education";
import { Helmet } from "react-helmet";

const Gallery = () => {
    useEffect(() => {
        var tabs = document.querySelector('.tab2');
        M.Tabs.init(tabs, {});
    }, []);

    return ( 
        <Layout>
            <Helmet> 
                <meta
                    name="description"
                    content="View our campus images and education material."
                />
                <title>Gallery</title>
            </Helmet>
            <div className="container">
                <div className="row mt-6">
                    <div className="col s12 m11">
                        <ul className="tabs tab2">
                            <li className="tab col s3"><a href="#campus" className="active main-color-text has-text-weight-bold">Campus Images</a></li>
                            <li className="tab col s3"><a  href="#edu" className="main-color-text has-text-weight-bold">Education</a></li>
                        </ul>
                    </div>
                    <CampusImages />
                    <Education />
                </div>
            </div>
        </Layout>
     );
}
 
export default Gallery;